module.exports = __webpack_public_path__ + "static/media/bg.a0cfb4cb.png";